
import { AreaChart, Area, PieChart, Pie, Cell } from "recharts"
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar } from 'recharts';
// import './dashboard-charts.css'

// const courseCompletionData = [
//   { month: "January", completion: 75 },
//   { month: "February", completion: 45 },
//   { month: "March", completion: 65 },
//   { month: "April", completion: 35 },
//   { month: "May", completion: 80 },
//   { month: "June", completion: 95 },
// ]

// Data for Rebooking Rate Donut - 45% as shown in image
const rebookingData = [
  { name: "Rebooked", value: 90, fill: "#00A900" }, // Bright green
  { name: "Not Rebooked", value: 10, fill: "#A6B9DA" }, // Light blue
]

// Custom gauge component for Monthly Visitors
const GaugeChart = ({ value, total }) => {
  const percentage = (value / total) * 100;
  const angle = (percentage / 100) * 180; // max 180 for semi-circle
  const radius = 80;
  const cx = 100;
  const cy = 100;

  // Convert angle to coordinates
  const x = cx + radius * Math.cos(Math.PI * (1 - percentage / 100));
  const y = cy - radius * Math.sin(Math.PI * (percentage / 100));

  const largeArcFlag = percentage > 50 ? 1 : 0;
  const strokeDasharray = `${percentage * 2.51} 251`;

  return (
    <div className="gauge-container" style={{ position: 'relative', width: '200px', height: '120px' }}>
      <svg width="200" height="120" viewBox="0 0 200 120">
        {/* Background Arc */}
        <path
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke="#E5E7EB"
          strokeWidth="10"
        />

        {/* Foreground Arc */}
        <path
          d={`M 20 100 A 80 80 0 ${largeArcFlag} 1 ${x} ${y}`}
          fill="none"
          stroke="#72675B"
          strokeWidth="10"
          strokeLinecap="round"
        />

        {/* End dot */}
        <circle cx={x} cy={y} r="7" fill="#72675B" stroke="white" strokeWidth="3" />
      </svg>

      {/* Center Text */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '28px', fontWeight: '600' }}>{value}</div>
        <div style={{ fontSize: '14px', color: '#4B5563' }}>New Policy Updates</div>
      </div>
    </div>
  );
};

export default function DashboardCharts({userData}) {
  // console.log("akjsfkjasdfa",userData)
//  const userData = {
//  productSoldMonthly: [
//     { month: 0, value: 0 },
//     { month: 1, value: 3 },
//     { month: 2, value: 6 },
//     { month: 3, value: 9 },
//     { month: 4, value: 13 },
//     { month: 5, value: 16 },
//     { month: 6, value: 18 },
//   ],
//   membershipSoldMonthly: [
//     { label: '1', value: 3 },
//     { label: '2', value: 2 },
//     { label: '3', value: 10 },
//     { label: '4', value: 4 },
//     { label: '5', value: 3 },
//     { label: '6', value: 2 },
//     { label: '7', value: 5 }, // highlighted
//     { label: '8', value: 4 },
//   ],
// };
  return (
    <div className="dashboard-container dashboard-wrapper">
      <div className="charts-row">
        {/* Course Completion Chart */}
     {
          userData?.averageRatingsData &&
           <div className="chart-card">
          <div className="chart-header">
            <div>
            <h3 className="chart-title">Completed Courses</h3>
             <div className="visitors-stats">
               
                <span className="visitors-growth">
                 {new Date().toLocaleString("en-US", { month: "short" })}:{" "} {
            userData.averageRatingsData.find(
              (item) =>
                item.month ===
                new Date().toLocaleString("en-US", { month: "short" })
            )?.completion ?? 0
          }
                </span>
              </div>
             </div>
          </div>
          <div className="chart-content">
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={userData?.averageRatingsData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                <XAxis
                  dataKey="month"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 11, fill: "#9CA3AF" }}
                  interval={0}
                  angle={0}
                />
                <YAxis
                  domain={[0, 100]}
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 11, fill: "#9CA3AF" }}
                  ticks={[0, 25, 50, 75, 100]}
                />
                <Area
                  type="monotone"
                  dataKey="completion"
                  stroke="#D1D5DB"
                  strokeWidth={2}
                  fill="#F9FAFB"
                  fillOpacity={0.8}
                />
                <Tooltip
  contentStyle={{ backgroundColor: 'white', border: '1px solid #ccc', fontSize: 12 }}
  labelStyle={{ color: '#6B7280' }}
  cursor={{ stroke: '#D1D5DB', strokeWidth: 1 }}
/>
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        }



        {/* Rebooking Rate Donut Chart */}
      <div className="chart-card">
          <div className="chart-header">
            <div>
              <h3 className="chart-title">Policy Updates</h3>
              <div className="visitors-stats">
                {/* <span className="visitors-number">2,648K</span> */}
                <span className="visitors-growth">{userData?.newPolicies}%</span>
              </div>
            </div>
            {/* <div className="chart-meta">
              <span className="meta-dots">⋯</span>
              <span className="meta-text">Last 3 days</span>
            </div> */}
          </div>
          <div className="chart-content gauge-content" style={{ display: 'flex', justifyContent: 'center' }}>
        <GaugeChart value={userData?.newPolicies} total={100} />
      </div>
        </div>
      </div>
    </div>
  )
}
